import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Helper from '@ember/component/helper';
import { formatHour } from 'beebee-base/lib/utility';
import { inject } from '@ember/service';

var _class, _descriptor;

/**
 * Helper per formattare orari con supporto timezone
 * Uso: {{format-hour time}}                          → HH:mm con tz sessione
 *      {{format-hour time 'HH:mm:ss'}}               → formato Moment personalizzato
 *      {{format-hour time time_zone=tz}}             → tz come named arg per override
 */
let FormatHourHelper = (_class = class FormatHourHelper extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  compute([time, format], {
    time_zone
  } = {}) {
    if (!time) return null;

    // timezone dalla sessione; time_zone named arg per override eccezionale
    const tz = time_zone ?? this.session.me?.time_zone;
    return formatHour(time, tz, format);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { FormatHourHelper as default };
//# sourceMappingURL=format-hour.js.map
